import React from 'react';
import { Helmet } from "react-helmet"; 
import Hero from '../../components/Home/Hero';
import Services from '../../components/Home/Services';
import Interest from '../../components/Home/Interest';
import Training from '../../components/Home/Training';
import Testimonials from '../../components/Home/Testimonials';
import Partners from '../../components/Home/Partners';

const Home = () => {
  return (
    <>
      <Helmet>
  {/* Page Title */}
  <title>Aptech Lekki Centre | Learn Coding, IT Skills, and Tech Training in Lagos</title>

  {/* Google Analytics Tag */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Google Tag Manager */}
  <script>
    {`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-TJ53RH2N');
    `}
  </script>

  {/* Basic Meta Tags */}
  <html lang="en" />
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  
  <meta
    name="description"
    content="Join Aptech Lekki Centre for globally recognized IT and coding training. Learn Web Development, Software Engineering, Mobile App Development, Data Analytics, and more in Lagos, Nigeria."
  />
  
  <meta
    name="keywords"
    content="Aptech Lekki, IT training Lekki, Coding classes Lekki, Software development Lagos, Web development Nigeria, Learn programming Lagos, Digital marketing Lekki, Data analytics training Nigeria, Mobile App development Lekki"
  />
  
  {/* Open Graph Meta for social sharing */}
  <meta property="og:title" content="Aptech Lekki | Top IT Training and Coding School in Lagos" />
  <meta property="og:description" content="Kickstart your tech career with Aptech Lekki. Get hands-on training in coding, app development, data analytics, and more." />
  <meta property="og:url" content="https://aptechlekki.com/" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://aptechlekki.com/logo.png" />
  
  {/* Robots */}
  <meta name="robots" content="index, follow" />
  
  {/* Theme Color for Mobile */}
  <meta name="theme-color" content="#FFBA00" />

  {/* Structured Data (JSON-LD) */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": "Aptech Lekki Centre",
        "url": "https://aptechlekki.com/",
        "logo": "https://aptechlekki.com/logo.png",
        "description": "Aptech Lekki Centre offers hands-on IT training in Web Development, Software Engineering, Mobile App Development, Data Analytics, and Digital Marketing in Lagos, Nigeria.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Your Street Address Here",
          "addressLocality": "Lekki",
          "addressRegion": "Lagos",
          "postalCode": "101245",
          "addressCountry": "NG"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+2348134370701",
          "contactType": "Customer Support"
        },
        "sameAs": [
          "https://www.facebook.com/aptechlekki",
          "https://www.instagram.com/aptechlekki",
          "https://www.linkedin.com/company/aptechlekki"
        ]
      }
    `}
  </script>
</Helmet>


      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe 
          src="https://www.googletagmanager.com/ns.html?id=GTM-TJ53RH2N"
          height="0" 
          width="0" 
          style={{ display: 'none', visibility: 'hidden' }} 
          title="Google Tag Manager"
        ></iframe>
      </noscript>
      {/* End Google Tag Manager (noscript) */}
      
      <Hero />
      <Services />
      <Interest />
      <Training />
      <Testimonials />
      <Partners />
    </>
  )
}

export default Home;